(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrition-table"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nutrition-table')) {
  customElements.define(
    'nutrition-table',
    class NutritionTable extends HTMLElement {
      connectedCallback() {
        const table = this.querySelector('table');
        if (!table || table.dataset.nutritionReady === 'true') return;

        table.dataset.nutritionReady = 'true';
        table.classList.add('nutrition-table');
        this.normalizeHeaders(table);
        this.ensureCaption(table);
      }

      normalizeHeaders(table) {
        if (!table.tHead && table.rows.length) {
          const thead = table.createTHead();
          thead.appendChild(table.rows[0]);
        }

        if (table.tHead) {
          Array.from(table.tHead.rows).forEach((row) => {
            Array.from(row.cells).forEach((cell) => {
              this.replaceWithHeader(cell, 'col');
            });
          });
        }

        Array.from(table.tBodies).forEach((tbody) => {
          Array.from(tbody.rows).forEach((row) => {
            if (row.cells[0]) this.replaceWithHeader(row.cells[0], 'row');
          });
        });
      }

      replaceWithHeader(cell, scope) {
        if (cell.tagName === 'TH') {
          cell.scope = scope;
          return;
        }

        const header = document.createElement('th');
        header.scope = scope;
        header.innerHTML = cell.innerHTML;
        Array.from(cell.attributes).forEach((attribute) => {
          header.setAttribute(attribute.name, attribute.value);
        });
        cell.replaceWith(header);
      }

      ensureCaption(table) {
        const captionText = this.dataset.caption;
        if (!captionText || table.querySelector('caption')) return;

        const caption = document.createElement('caption');
        caption.className = 'visually-hidden';
        caption.textContent = captionText;
        table.prepend(caption);
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
